import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { ILeistungRueckgemeldet } from '../_interfaces/leistung-rueckgemeldet';
//import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class LeistungRueckgemeldetService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'kopfdatenId', type: 'int'},
    {name: 'auftragspositionenId', type: 'int'},
    {name: 'positionsNr', type: 'int'},
    {name: 'artikelnummer', type: 'LeistungskatalogSpediteur'},
    {name: 'menge', type: 'decimal', decimals: 2},
    {name: 'preis', type: 'decimal', format: "$", decimals: 2},
    {name: 'lieferdatum', type: 'DateTimeOffset'}
  ];
    
  getLeistungenRueckgemeldetCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ leistungenRueckgemeldet: ILeistungRueckgemeldet[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'leistungenrueckgemeldet?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { leistungenRueckgemeldet: <ILeistungRueckgemeldet[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getLeistungRueckgemeldet(id: number): Observable<ILeistungRueckgemeldet> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeLeistungRueckgemeldet());
      //   observer.complete();
      // })
      return of(this.initializeLeistungRueckgemeldet());
    }

    return this.httpClient.get<ILeistungRueckgemeldet>(this.apiBaseUrl + 'leistungenrueckgemeldet/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  saveLeistungRueckgemeldet(leistungRueckgemeldet: ILeistungRueckgemeldet): Observable<ILeistungRueckgemeldet> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(leistungRueckgemeldet); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("LeistungRueckgemeldetService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("LeistungRueckgemeldetService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (leistungRueckgemeldet.id === 0) {
      return this.createLeistungRueckgemeldet(/*leistungRueckgemeldet*/itemToSave);
    }

    return this.updateLeistungRueckgemeldet(/*leistungRueckgemeldet*/itemToSave)

  }

  updateLeistungRueckgemeldet(leistungRueckgemeldet: ILeistungRueckgemeldet): Observable<ILeistungRueckgemeldet> {

    return this.httpClient.put<ILeistungRueckgemeldet>(this.apiBaseUrl + 'leistungenrueckgemeldet/' + leistungRueckgemeldet.id, leistungRueckgemeldet, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deleteLeistungRueckgemeldet(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'leistungenrueckgemeldet/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createLeistungRueckgemeldet(leistungRueckgemeldet: ILeistungRueckgemeldet): Observable<ILeistungRueckgemeldet> {
    return this.httpClient.post<ILeistungRueckgemeldet>(this.apiBaseUrl + 'leistungenrueckgemeldet', leistungRueckgemeldet, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializeLeistungRueckgemeldet(): ILeistungRueckgemeldet {
    return {
      id: 0,
      createdBy: '',
      created: /*''*/'0001-01-01T00:00:00.000Z', // fix
      modifiedBy: '',
      modified: /*''*/'0001-01-01T00:00:00.000Z', // fix
      rowVersion: '',
      kopfdatenId: null,
      auftragspositionenId: null,
      positionsNr: 0,
      artikelnummer: null,
      menge: 0,
      preis: 0,
      lieferdatum: null
    };
  }


}
